const doc = [({"da":({"js":({"admin":({"activities":({"live_nav":({"agenda":"Dagsorden", "setup":"Opsætning"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;